// Dependency-free so sentryEarly.ts can import it during bootstrap without
// pulling in model/Redux/api-URL modules.

/** True when served from a per-preview host (`<name>.preview.dev.bkbn.com`). */
export const isPreviewHost = (): boolean =>
  typeof window !== 'undefined' &&
  window.location.hostname.endsWith('.preview.dev.bkbn.com')
